module.exports = __webpack_public_path__ + "img/mini-020.e2558a75.jpg";